export default __webpack_public_path__ + "media/images/mailer-new/heading/warning-be28175bfd4bbcb577277425ae9d4382.png";